import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { keys } from "../queryKeys.js";
import * as api from "../api/incidents.js";

export function useIncidents(params, options = {}) {
  return useQuery({
    queryKey: keys.incidents.list(params),
    queryFn: () => api.fetchIncidents(params),
    ...options,
  });
}

export function useIncident(id, options = {}) {
  return useQuery({
    queryKey: keys.incidents.detail(id),
    queryFn: () => api.fetchIncident(id),
    enabled: !!id,
    ...options,
  });
}

export function useIncidentTimeline(id, params, options = {}) {
  return useQuery({
    queryKey: keys.incidents.timeline(id),
    queryFn: () => api.fetchIncidentTimeline(id, params),
    enabled: !!id,
    ...options,
  });
}

export function useIncidentAnalytics(params, options = {}) {
  return useQuery({
    queryKey: ["incidents", "analytics", params ?? {}],
    queryFn: () => api.fetchIncidentAnalytics(params),
    ...options,
  });
}

export function useCreateIncident() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createIncident,
    onSuccess: () => qc.invalidateQueries({ queryKey: keys.incidents.all }),
  });
}

export function useUpdateIncident() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => api.updateIncident(id, data),
    onSuccess: (_d, { id }) => {
      qc.invalidateQueries({ queryKey: keys.incidents.all });
      qc.invalidateQueries({ queryKey: keys.incidents.detail(id) });
    },
  });
}

export function useAcknowledgeIncident() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.acknowledgeIncident,
    onSuccess: (_d, id) => {
      qc.invalidateQueries({ queryKey: keys.incidents.all });
      qc.invalidateQueries({ queryKey: keys.incidents.detail(id) });
    },
  });
}

export function useResolveIncident() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.resolveIncident,
    onSuccess: (_d, id) => {
      qc.invalidateQueries({ queryKey: keys.incidents.all });
      qc.invalidateQueries({ queryKey: keys.incidents.detail(id) });
    },
  });
}

export function useUnacknowledgeIncident() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.unacknowledgeIncident,
    onSuccess: (_d, id) => {
      qc.invalidateQueries({ queryKey: keys.incidents.all });
      qc.invalidateQueries({ queryKey: keys.incidents.detail(id) });
    },
  });
}

export function useReopenIncident() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.reopenIncident,
    onSuccess: (_d, id) => {
      qc.invalidateQueries({ queryKey: keys.incidents.all });
      qc.invalidateQueries({ queryKey: keys.incidents.detail(id) });
    },
  });
}
